import { Duration } from 'luxon';
import React from 'react';

import { FontSize, RangeSelector, Switch, Text } from '../../../WidgetConfiguratorComponents/FormGroups';
import { BinCountSelectorFormGroup } from './BinCountSelectorFormGroup';
import { BinStepSizeFormGroup } from './BinStepSizeFormGroup';
import { ColourScaleSelectorFormGroup } from './ColourScaleSelectorFormGroup';
import { ConeCountFormGroup } from './ConeCountFormGroup';
import { PercentageLabelAngleSelector } from './PercentageLabelAngleSelector';

export const GeneralSettingsConfigurator = ({ viewblockState, setViewblockState }) => {
    const onSettingsChange = (key, value) => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                [key]: value,
            },
        }));
    };

    const onTimeRangeChange = (timeRange) => {
        const timeRangeISO = timeRange.map((hours) => Duration.fromObject({ hours }).toISO()).join('--');
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                timeRange: timeRangeISO,
            },
            databilities: prev.databilities.map((datability) => {
                return {
                    ...datability,
                    timeRange: timeRangeISO,
                };
            }),
        }));
    };

    const timeRangeInHours = viewblockState.settings.timeRange
        .split('--')
        .map(Duration.fromISO)
        .map((DurationResponse) => DurationResponse.values.hours);

    return (
        <>
            <Text label={'Label'} value={viewblockState.settings.label} onChange={(label) => onSettingsChange('label', label)} />
            <Switch
                label={'Relative frequency'}
                value={!!viewblockState.settings.relativeFrequencyAxis}
                onChange={(relativeFrequencyAxis) => onSettingsChange('relativeFrequencyAxis', relativeFrequencyAxis)}
            />
            <ConeCountFormGroup coneCount={viewblockState.settings.coneCount} onChange={(coneCount) => onSettingsChange('coneCount', coneCount)} />
            <PercentageLabelAngleSelector
                percentageLabelAngle={viewblockState.settings.percentageLabelAngle}
                onChange={(percentageLabelAngle) => onSettingsChange('percentageLabelAngle', percentageLabelAngle)}
            />
            <FontSize fontSize={viewblockState.settings.fontSize} onChange={(fontSize) => onSettingsChange('fontSize', fontSize)} />
            <BinCountSelectorFormGroup binCount={viewblockState.settings.binCount} onChange={(binCount) => onSettingsChange('binCount', binCount)} />
            <BinStepSizeFormGroup binStepSize={viewblockState.settings.binStepSize} onChange={(binStepSize) => onSettingsChange('binStepSize', binStepSize)} />
            <ColourScaleSelectorFormGroup
                colourScale={viewblockState.settings.colourScale}
                onChange={(colourScale) => onSettingsChange('colourScale', colourScale)}
                colourCount={viewblockState.settings.binCount}
            />
            <RangeSelector
                label={`Time range (hours)`}
                rangeSelectorProps={{
                    marks: {
                        [-24]: -24,
                        [-12]: -12,
                        [0]: 0,
                        [12]: 12,
                        [24]: 24,
                        [48]: 48,
                        [72]: 72,
                    },
                    step: 12,
                    onChange: onTimeRangeChange,
                    min: -24,
                    max: 72,
                    defaultValue: timeRangeInHours || [0, 72],
                    value: timeRangeInHours,
                }}
            />
        </>
    );
};
